import joi from 'joi';
import { dateDefault } from './types.def';

export const job = joi.object({
	id: joi.string(),
	url: joi.string(),
	name: joi.string(),
	createdAt: dateDefault,
	updatedAt: dateDefault,
	schema: joi.string(),
});
